// Coming Up: countdowns from config/seasons.json, always the next five, soonest first, through the day itself (Oct 27,
// Jared: a full page even when they're weeks off; it used to show each only from `showDays` before). How often it
// airs is its loop rule's business (rules.mjs).
import { registerDisplay } from '../navigation.mjs';
import { escapeHtml } from '../utils/string.mjs';
import SnapshotDisplay from './snapshot-display.mjs';
import { dayKey } from './format.mjs';
import { countdownIcon } from './icons.mjs';

const { seasons } = window.RHL;
const DAY = 86400000;
const ROWS = 5;

// whole days between two YYYY-MM-DD dates
const daysBetween = (from, to) => Math.round((Date.parse(`${to}T12:00:00Z`) - Date.parse(`${from}T12:00:00Z`)) / DAY);

const upcoming = (now) => {
	const today = dayKey(now);
	return (seasons.countdowns ?? [])
		.map((c) => ({ ...c, days: daysBetween(today, c.date) }))
		.filter((c) => c.days >= 0)
		.sort((a, b) => a.days - b.days)
		.slice(0, ROWS);
};

const when = (c) => {
	const date = new Date(`${c.date}T12:00:00Z`);
	return new Intl.DateTimeFormat('en-US', {
		timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric',
	}).format(date);
};

class ComingUp extends SnapshotDisplay {
	constructor(navId, elemId) {
		super(navId, elemId, 'Coming Up', { seconds: 18 });
	}

	// eslint-disable-next-line class-methods-use-this
	hasData() {
		return upcoming(new Date()).length > 0;
	}

	// eslint-disable-next-line class-methods-use-this
	render(now) {
		const rows = upcoming(now).map((c) => {
			const count = c.days === 0 ? 'Today' : `${c.days}`;
			const unit = c.days === 0 ? '' : (c.days === 1 ? 'day' : 'days');
			return `<div class="countdown"><div class="n${c.days === 0 ? ' today' : ''}">${count}</div><div class="unit">${unit}</div>
				<div class="ic">${countdownIcon(c.name)}</div><div class="what${c.name.length > 20 ? ' long' : ''}">${escapeHtml(c.name)}</div><div class="date">${when(c)}</div></div>`;
		});
		return `<div class="countdowns">${rows.join('')}</div>`;
	}
}

registerDisplay(new ComingUp(28, 'coming-up'));
